<script>
import {ref} from "vue";
import {useCartStore} from "@js/store/CartStore.js";
import IconX from "@js/components/Icons/IconX.vue";

export default {
    name: "CartClearConfirmPopup",
    components: {IconX},
    setup() {
        const cartStore = useCartStore()
        const modalFormSuccessPopupRef = ref(null)

        const closeModal = () => {
            cartStore.isCartClearModalVisible = false
        }

        const handleBackgroundClick = (event) => {
            if (!modalFormSuccessPopupRef.value.contains(event.target)) {
                closeModal()
            }
        }

        return {
            cartStore,
            closeModal,
            modalFormSuccessPopupRef,
            handleBackgroundClick
        }
    },
}
</script>

<template>
    <div v-if="cartStore.isCartClearModalVisible"
         class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 transition-opacity"
         @click="handleBackgroundClick">
        <div ref="modalFormSuccessPopupRef"
             class="relative bg-gray-800 text-white rounded-2xl shadow-lg w-[90%] md:w-auto px-6 md:px-10 py-10 intro-y">
            <button @click.prevent="closeModal"
                    class="absolute top-2 right-2 text-gray-400 md:hover:text-white focus:outline-none">
               <IconX class="h-6 w-6 stroke-white"/>
            </button>
            <div class="text-center">
                <p class="text-2xl font-bold">
                    Очистить корзину?
                </p>
                <div class="grid grid-cols-2 gap-2 md:gap-5">
                    <button type="button" @click.prevent="cartStore.clearCart"
                            class="flex items-center justify-center w-full gap-2 leading-tight uppercase text-nowrap bg-navHoverColor md:hover:bg-navHoverColor/80 text-white focus:outline-none focus:ring-0 font-bold rounded text-xs md:text-sm px-5 py-4 transition mt-5">
                        Очистить корзину
                    </button>
                    <button type="button" @click.prevent="cartStore.isCartClearModalVisible = false"
                            class="flex items-center justify-center w-full gap-2 leading-tight uppercase text-nowrap bg-gray-300 md:hover:bg-gray-300/80 text-black focus:outline-none focus:ring-0 font-bold rounded text-xs md:text-sm px-5 py-4 transition mt-5">
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
